import { Box } from '@material-ui/core';
import React, { FC } from 'react';
import { CreateButton } from 'react-admin';

const BlogListTitle: FC = () => {
  return (
    <Box marginTop='2em'>
      <div className='active-prizes-container'>Blog Management</div>
      <Box display='flex' justifyContent='flex-end'>
        <CreateButton
          className='add-button'
          label='Add new '
          to='blogs/create'
        />
      </Box>
    </Box>
  );
};

export default BlogListTitle;
